import { SvgIcon, type SvgIconProps } from "@mui/material";

interface ProductGlyphProps extends Omit<SvgIconProps, "color"> {
    color?: string;
    size?: number;
}

const ProductGlyph = ({ color = "#818cf8", size = 18, sx, ...rest }: ProductGlyphProps) => (
    <SvgIcon
        viewBox="0 0 18 18"
        sx={{ width: size, height: size, fontSize: size, ...sx }}
        {...rest}
    >
        <circle cx="9" cy="9" r="8" stroke={color} strokeOpacity="0.35" strokeWidth="1" strokeDasharray="2 2" fill="none" />
        <circle cx="9" cy="9" r="4.5" stroke={color} strokeOpacity="0.65" strokeWidth="1.2" fill="none" />
        <circle cx="9" cy="9" r="1.8" fill={color} />
    </SvgIcon>
);

export default ProductGlyph;
